const LINK_TOKEN_KEY = 'neveroverpay_plaid_link_token';

export function savedPlaidLinkToken() {
  try {
    return sessionStorage.getItem(LINK_TOKEN_KEY) || '';
  } catch {
    return '';
  }
}

export function loadPlaidScript() {
  return new Promise((resolve, reject) => {
    if (window.Plaid) {
      resolve(window.Plaid);
      return;
    }
    const existing = document.querySelector('script[data-plaid-link]');
    if (existing) {
      existing.addEventListener('load', () => resolve(window.Plaid));
      existing.addEventListener('error', () => reject(new Error('Could not load Plaid Link')));
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
    script.async = true;
    script.dataset.plaidLink = 'true';
    script.onload = () => resolve(window.Plaid);
    script.onerror = () => reject(new Error('Could not load Plaid Link'));
    document.head.appendChild(script);
  });
}

export async function openPlaidLink({ linkToken, receivedRedirectUri, onSuccess }) {
  const token = linkToken || savedPlaidLinkToken();
  if (!token) throw new Error('Missing Plaid Link token');
  try {
    sessionStorage.setItem(LINK_TOKEN_KEY, token);
  } catch {
    /* ignore */
  }
  const Plaid = await loadPlaidScript();
  return new Promise((resolve, reject) => {
    const handler = Plaid.create({
      token,
      receivedRedirectUri: receivedRedirectUri || undefined,
      onSuccess: async (publicToken) => {
        try {
          try {
            sessionStorage.removeItem(LINK_TOKEN_KEY);
          } catch {
            /* ignore */
          }
          if (onSuccess) await onSuccess(publicToken);
          resolve(publicToken);
        } catch (err) {
          reject(err);
        }
      },
      onExit: (err) => {
        if (err) reject(new Error(err.error_message || err.display_message || 'Plaid Link closed'));
        else resolve(null);
      },
    });
    handler.open();
  });
}
